'use strict';
{
    angular.module('tf.portfolio.whatIfMobile', [])

        .controller('openMobOptionPickerCtrl', ['$scope', 'uiGridConstants', '$http', 'optionPriceService', 'chainService', '$uibModal', 'companyService', function ($scope, uiGridConstants, $http, optionPriceService, chainService, $uibModal, companyService) {

            $scope.openMobOptionSelector = function() {
                $scope.createWhatIfMobileModal();
            };

            $scope.createWhatIfMobileModal = function (size) {

                var modalInstance = $uibModal.open({
                    templateUrl: 'app/portfolio/templates/mobileWhatIf/mobileWhatIf.tpl.html',
                    controller: 'optionPickerCtrl',
                    size: size,
                    resolve : {
                        stock : function() {
                            return $scope.stock;
                        }
                    }

                });

                modalInstance.result.then(function (selectedPositions) {
                    $scope.$emit('whatif.mobile.close', selectedPositions);
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });

            };

            $scope.inputStock = "";
            $scope.optionChainInput = {
                search : null,
                type : "call"
            };


            $scope.toggleChartFullScreen = function() {
                $scope.chartFullScreen = !$scope.chartFullScreen;
                //    TODO: add function to recalculate resizeContainers() from chartControllers here.
            };

            $scope.underlyings = null;

            $scope.findCompanies = async function(input) {
                if ($scope.companies == null) {
                    $scope.companies = await companyService.companies(true);
                }
                return companyService.findCompanies($scope.companies, input);
            };
        }])

        .controller('optionPickerCtrl', ['$scope', 'uiGridConstants', '$http', 'optionPriceService', 'spreadService', 'openInterestService', 'chainService', '$uibModal', 'stock', '$uibModalInstance', function ($scope, uiGridConstants, $http, optionPriceService, spreadService, openInterestService, chainService, $uibModal, stock, $uibModalInstance) {

            $scope.atStart = false;
            $scope.atEnd = false;

            $scope.stock = stock;

            $scope.moveSeries = function(next){
                if (next && $scope.chain.series[$scope.selectedSeriesIndex + 1]) {
                    $scope.selectedSeriesIndex += 1;
                    $scope.getChain();
                } else if ($scope.chain.series[$scope.selectedSeriesIndex - 1]) {
                    $scope.selectedSeriesIndex -= 1;
                    $scope.getChain();
                }
            };

            $scope.selectedSeriesIndex = 0;
            $scope.getChain = function() {
                chainService($scope.stock.code.substring(0, 3).toUpperCase()).then(function (chain){
                    $scope.chain = chain;
                    $scope.updateSeries($scope.chain.series[$scope.selectedSeriesIndex]);
                    $scope.loadChain($scope.chain);
                });
            };
            $scope.upperLimitPointer = 0;
            $scope.lowerLimitPointer = 0;

            $scope.getChain();

            $scope.updateSeries = function(series) {
                $scope.currentSeries = series;
                optionPriceService($scope.chain.code, series.expiry).then(function(prices) {
                    $scope.currentPrice = prices;

                    // openInterestService($scope.chain.code).then(function(oi) {
                    //     $scope.oi = oi;

                        spreadService($scope.chain.code, series.expiry).then(function(spreads){
                            $scope.spreads = spreads;
                            $scope.mergeData();
                            $scope.callOptions = $scope.optionsChainData;
                            $scope.putOptions = $scope.optionsChainData;
                            $scope.midPoint = Math.floor($scope.optionsChainData.length / 2);
                            $scope.upperLimitPointer = $scope.midPoint + 5;
                            $scope.lowerLimitPointer = $scope.midPoint - 5;
                            $scope.range = $scope.upperLimitPointer - $scope.lowerLimitPointer;
                            $scope.atStart = false;
                            $scope.atEnd = false;
                        });
                    // });

                });
            };

            $scope.extendResults = function(up){
                if (up) {
                    if ($scope.optionsChainData[$scope.upperLimitPointer + 5]) {
                        $scope.upperLimitPointer = $scope.upperLimitPointer + 5;
                        $scope.range = $scope.upperLimitPointer - $scope.lowerLimitPointer;
                        $scope.atEnd = false;
                    } else {
                        $scope.upperLimitPointer = $scope.optionsChainData.length - 1;
                        $scope.range = $scope.upperLimitPointer - $scope.lowerLimitPointer;
                        $scope.atEnd = true;
                    }

                } else {
                    if ($scope.lowerLimitPointer - 5 > 0) {
                        $scope.lowerLimitPointer = $scope.lowerLimitPointer - 5;
                        $scope.range = $scope.upperLimitPointer - $scope.lowerLimitPointer;
                        $scope.atStart = false;
                    } else {
                        $scope.lowerLimitPointer = 0;
                        $scope.range = $scope.upperLimitPointer - $scope.lowerLimitPointer;
                        $scope.atStart = true;
                    }
                }
            };

            $scope.mergeData = function() {
                var series = $scope.currentSeries;
                var prices = $scope.currentPrice;
                var spreads = $scope.spreads;
                // var oi = $scope.oi;

                $scope.optionsChainData = series.ladder.map(function (rung) {
                    var put = null;
                    if (rung.put) {
                        put = {
                            option: rung.put,
                            price: prices.options[rung.put.code].p,
                            delta: prices.options[rung.put.code].d,
                            gamma: prices.options[rung.put.code].g,
                            vega: prices.options[rung.put.code].ve,
                            theta: prices.options[rung.put.code].t,
                            vol: prices.options[rung.put.code].v,
                            spread : spreads.spread[rung.put.code],
                            itm: prices.price <= rung.level
                            // ,
                            // oi : oi.interest[rung.put.code] || 0
                        };
                    }

                    var call = null;
                    if (rung.call) {
                        call = {
                            option: rung.call,
                            price: prices.options[rung.call.code].p,
                            delta: prices.options[rung.call.code].d,
                            gamma: prices.options[rung.call.code].g,
                            vega: prices.options[rung.call.code].ve,
                            theta: prices.options[rung.call.code].t,
                            vol: prices.options[rung.call.code].v,
                            spread : spreads.spread[rung.call.code],
                            itm: prices.price >= rung.level
                            // ,
                            // oi : oi.interest[rung.call.code] || 0
                        };
                    }
                    return {
                        special: false,
                        level: rung.level,
                        put: put,
                        call: call
                    };
                });
            };

            $scope.loadChain = function(chain) {
                $scope.years = [];

                var tmpYear = {
                    year : 0,
                    series : []
                };
                for (var i = 0; i < chain.series.length; i++) {
                    var series = chain.series[i];

                    if (series.expiry.getFullYear() != tmpYear.year) {
                        tmpYear = {
                            year: series.expiry.getFullYear(),
                            series: [],
                            firstSeries : series,
                            defaultSeries : series,
                            firstQuarterSeries : null

                        };
                        $scope.years.push(tmpYear);
                    }

                    // XJO usually uses a quarterly expiry
                    if ($scope.inputStock == 'XJO' && tmpYear.firstQuarterSeries == null) {
                        if (((series.expiry.getMonth() + 1) % 3) == 0) {
                            tmpYear.firstQuarterSeries = series;
                        }
                    }

                    if (chain.asAt.getTime() == tmpYear.defaultSeries.expiry.getTime() && tmpYear.defaultSeries != series) {
                        tmpYear.defaultSeries = series;
                    }

                    // TODO try not to mangle the data that was passed in
                    series.year = tmpYear;
                    tmpYear.series.push(series);
                }
            };

            $scope.onSelectYear = function(year) {
                if (year.defaultSeries != $scope.currentSeries) {
                    $scope.updateSeries(year.defaultSeries);
                }
            };

            $scope.onSelectSeries = function(series) {
                // TODO need to use the input filter price too if we have it
                if (series != $scope.currentSeries) {
                    $scope.updateSeries(series);
                }
            };

            $scope.preWhatIfs = [];

            $scope.addGroup = function(idx, group, e) {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }

                var newGroup = angular.copy(group);
                newGroup.no = $scope.groups.length + 1;
                $scope.groups.splice(idx + 1, 0, newGroup);
            };

            $scope.addToPreWhatIf = function(position, call, e){
                if (call) {
                    var code = position.call.option.code;
                    position.call.selected = true;
                } else {
                    var code = position.put.option.code;
                    position.put.selected = true;
                }
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }

                var tradeToAdd = {
                    code : code,
                    quantity : 0
                };
                var exists = false;
                for (var i = 0; i < $scope.preWhatIfs.length; i++) {
                    if ($scope.preWhatIfs[i].code == tradeToAdd.code) {
                        exists = true;
                    }
                }
                if (!exists) {
                    $scope.preWhatIfs.push(tradeToAdd);
                }


            };

            $scope.removePreWhatIf = function(position, call, e){
                if (call) {
                    var code = position.call.option.code;
                    position.call.selected = false;
                } else {
                    var code = position.put.option.code
                    position.put.selected = false;
                }

                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }

                var tradeToAdd = {
                    code : code,
                    quantity : 0
                };

                $scope.preWhatIfs = $scope.preWhatIfs.filter(function(w) {
                    return w.code != tradeToAdd.code;
                });


            };

            $scope.closeOptionSelector = function(){
                $uibModalInstance.close($scope.preWhatIfs);
            }

        }])
}
